import { useState, useEffect } from 'react';
import { api } from '../../context/AuthContext';

export default function AdminShops() {
  const [shops, setShops] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState('ALL');

  useEffect(() => { load(); }, []);

  const load = async () => {
    setLoading(true);
    try { const { data } = await api.get('/admin/shops'); setShops(data); }
    catch {} finally { setLoading(false); }
  };

  const toggle = async (id) => {
    const { data } = await api.put(`/admin/shops/${id}/toggle`);
    setShops(s => s.map(x => x.id === id ? { ...x, shop_active: data.shop_active } : x));
  };

  const filtered = shops.filter(s => filter === 'ALL' || s.shop_type === filter);

  return (
    <div className="max-w-5xl mx-auto px-4 py-8">
      <h1 className="text-2xl font-black mb-6">🗺️ Talleres y Repuesteras</h1>

      <div className="flex gap-2 mb-6">
        {[['ALL','Todos'],['TALLER','🔧 Talleres'],['REPUESTERA','🛞 Repuesteras'],['GRUA','🚛 Grúas']].map(([v,l]) => (
          <button key={v} onClick={() => setFilter(v)}
            className={`px-4 py-2 rounded-full text-sm font-medium ${filter === v ? 'bg-black text-white' : 'bg-gray-100'}`}>
            {l}
          </button>
        ))}
        <span className="ml-auto text-sm text-gray-400 self-center">{filtered.length} registros</span>
      </div>

      {loading ? (
        <div className="flex justify-center py-20"><div className="w-10 h-10 border-4 border-primary border-t-transparent rounded-full animate-spin" /></div>
      ) : (
        <div className="bg-white rounded-xl shadow-sm overflow-hidden">
          <table className="w-full text-sm">
            <thead className="bg-gray-50 text-left">
              <tr>
                <th className="p-4 font-semibold">Negocio</th>
                <th className="p-4 font-semibold">Tipo</th>
                <th className="p-4 font-semibold">Dirección</th>
                <th className="p-4 font-semibold">Plan</th>
                <th className="p-4 font-semibold">Mapa</th>
              </tr>
            </thead>
            <tbody className="divide-y">
              {filtered.map(s => (
                <tr key={s.id} className={s.shop_active ? '' : 'opacity-50 bg-gray-50'}>
                  <td className="p-4">
                    <p className="font-semibold">{s.name}</p>
                    <p className="text-xs text-gray-400">{s.email}</p>
                  </td>
                  <td className="p-4">
                    <span className={`px-2 py-1 rounded-full text-xs font-bold ${s.shop_type === 'TALLER' ? 'bg-red-100 text-red-700' : s.shop_type === 'GRUA' ? 'bg-orange-100 text-orange-700' : 'bg-blue-100 text-blue-700'}`}>
                      {s.shop_type === 'TALLER' ? '🔧 Taller' : s.shop_type === 'GRUA' ? '🚛 Grúa' : '🛞 Repuestera'}
                    </span>
                  </td>
                  <td className="p-4 text-gray-500 text-xs max-w-[200px] truncate">{s.shop_address || '—'}</td>
                  <td className="p-4">
                    <span className={`text-xs font-bold px-2 py-1 rounded ${s.subscription_plan === 'PREMIUM' ? 'bg-yellow-100 text-yellow-700' : 'bg-blue-100 text-blue-700'}`}>
                      {s.subscription_plan}
                    </span>
                  </td>
                  <td className="p-4">
                    <button onClick={() => toggle(s.id)}
                      className={`relative inline-flex h-6 w-11 items-center rounded-full transition-colors ${s.shop_active ? 'bg-green-500' : 'bg-gray-300'}`}>
                      <span className={`inline-block h-4 w-4 transform rounded-full bg-white transition-transform ${s.shop_active ? 'translate-x-6' : 'translate-x-1'}`} />
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          {filtered.length === 0 && (
            <p className="text-center text-gray-400 py-12">No hay registros</p>
          )}
        </div>
      )}
    </div>
  );
}
